import { createAction } from './core';
// PUBLIC API
export const updateIsUserAdminById = createAction('operations/update-is-user-admin-by-id', ['User']);
// PUBLIC API
export const updateUserProfile = createAction('operations/update-user-profile', ['User']);
// PUBLIC API
export const syncMyAdminStatus = createAction('operations/sync-my-admin-status', ['User']);
// PUBLIC API
export const completeOnboarding = createAction('operations/complete-onboarding', ['User']);
// PUBLIC API
export const resendVerificationEmail = createAction('operations/resend-verification-email', []);
// PUBLIC API
export const createTrade = createAction('operations/create-trade', ['User', 'Trade', 'TradeTag', 'Account', 'TradeCustomFieldDefinition', 'TradeCustomFieldValue', 'TradeTagSuggestion', 'TradingSession', 'PendingSessionMerge', 'Payout']);
// PUBLIC API
export const updateTrade = createAction('operations/update-trade', ['User', 'Trade', 'TradeTag', 'Account', 'TradeCustomFieldDefinition', 'TradeCustomFieldValue', 'TradeTagSuggestion']);
// PUBLIC API
export const deleteTrade = createAction('operations/delete-trade', ['User', 'Trade']);
// PUBLIC API
export const deleteTrades = createAction('operations/delete-trades', ['User', 'Trade']);
// PUBLIC API
export const importTradesFromCSV = createAction('operations/import-trades-from-csv', ['User', 'Trade', 'Account', 'TradingSession', 'PendingSessionMerge', 'Payout']);
// PUBLIC API
export const createAccount = createAction('operations/create-account', ['User', 'Account', 'AccountGroup', 'TradingStrategy', 'PropFirmTemplate', 'AccountCharge']);
// PUBLIC API
export const createAccounts = createAction('operations/create-accounts', ['User', 'Account', 'AccountGroup', 'TradingStrategy', 'PropFirmTemplate', 'AccountCharge']);
// PUBLIC API
export const updateAccount = createAction('operations/update-account', ['User', 'Account', 'AccountGroup', 'TradingStrategy', 'TradovateSyncedAccount', 'PropFirmTemplate', 'AccountCharge', 'Notification']);
// PUBLIC API
export const deleteAccount = createAction('operations/delete-account', ['User', 'Account', 'Trade', 'AccountCharge']);
// PUBLIC API
export const respondToRuleUpdatePrompts = createAction('operations/respond-to-rule-update-prompts', ['User', 'Account', 'PropFirmTemplate', 'PropFirmAccountType', 'PropFirmTier', 'PropFirmPhase']);
// PUBLIC API
export const linkFundedToPredecessor = createAction('operations/link-funded-to-predecessor', ['User', 'Account', 'AccountCharge']);
// PUBLIC API
export const unlinkFundedPredecessor = createAction('operations/unlink-funded-predecessor', ['User', 'Account']);
// PUBLIC API
export const setFundedPredecessor = createAction('operations/set-funded-predecessor', ['User', 'Account', 'AccountCharge']);
// PUBLIC API
export const respondToFundedPrompts = createAction('operations/respond-to-funded-prompts', ['User', 'Account', 'AccountCharge']);
// PUBLIC API
export const connectMetaApiAccount = createAction('operations/connect-meta-api-account', ['User', 'Account', 'MetaApiConnection', 'Trade']);
// PUBLIC API
export const disconnectMetaApiAccount = createAction('operations/disconnect-meta-api-account', ['User', 'MetaApiConnection']);
// PUBLIC API
export const triggerManualPoll = createAction('operations/trigger-manual-poll', ['User', 'MetaApiConnection', 'Trade', 'Account']);
// PUBLIC API
export const pauseMetaApiConnection = createAction('operations/pause-meta-api-connection', ['User', 'MetaApiConnection']);
// PUBLIC API
export const resumeMetaApiConnection = createAction('operations/resume-meta-api-connection', ['User', 'MetaApiConnection']);
// PUBLIC API
export const startTradovateOAuth = createAction('operations/start-tradovate-oauth', ['User', 'TradovateConnection']);
// PUBLIC API
export const confirmTradovateImport = createAction('operations/confirm-tradovate-import', ['User', 'TradovateConnection', 'TradovateSyncedAccount', 'Account', 'AccountGroup', 'PropFirmTemplate', 'PropFirmTier', 'TradingStrategy', 'TradovateDiscoveredAccount', 'AccountCharge']);
// PUBLIC API
export const syncTradovateNow = createAction('operations/sync-tradovate-now', ['User', 'TradovateConnection', 'TradovateSyncedAccount', 'Trade', 'Account', 'TradingSession', 'PendingSessionMerge', 'Payout', 'PayoutSuggestion', 'TradovateDiscoveredAccount', 'AccountResetSuggestion', 'Notification', 'TradovateQuotaSample', 'TradovateApiIncident', 'TradovateContract', 'TradovateShadowDiff', 'TradovateSocketLease', 'TradovateWsLatency', 'TradovateWsAccountEvent', 'TradovateWsReauthEvent']);
// PUBLIC API
export const fullResyncTradovate = createAction('operations/full-resync-tradovate', ['User', 'TradovateConnection', 'TradovateSyncedAccount', 'Trade', 'Account', 'TradingSession', 'PendingSessionMerge', 'Payout', 'PayoutSuggestion', 'TradovateDiscoveredAccount', 'AccountResetSuggestion', 'Notification', 'TradovateQuotaSample', 'TradovateApiIncident', 'TradovateContract', 'TradovateShadowDiff', 'TradovateSocketLease', 'TradovateWsLatency', 'TradovateWsAccountEvent', 'TradovateWsReauthEvent']);
// PUBLIC API
export const disconnectTradovate = createAction('operations/disconnect-tradovate', ['User', 'TradovateConnection', 'TradovateSyncedAccount']);
// PUBLIC API
export const reconnectTradovate = createAction('operations/reconnect-tradovate', ['User', 'TradovateConnection']);
// PUBLIC API
export const completeTradovateOAuth = createAction('operations/complete-tradovate-oauth', ['User', 'TradovateConnection']);
// PUBLIC API
export const assignTradovateConnectionPropFirm = createAction('operations/assign-tradovate-connection-prop-firm', ['User', 'TradovateConnection', 'PropFirmTemplate']);
// PUBLIC API
export const dismissTradovateDiscoveredAccount = createAction('operations/dismiss-tradovate-discovered-account', ['TradovateConnection', 'TradovateDiscoveredAccount']);
// PUBLIC API
export const acceptPayoutSuggestion = createAction('operations/accept-payout-suggestion', ['PayoutSuggestion']);
// PUBLIC API
export const dismissPayoutSuggestion = createAction('operations/dismiss-payout-suggestion', ['PayoutSuggestion']);
// PUBLIC API
export const answerCashMovementQuestion = createAction('operations/answer-cash-movement-question', ['CashMovementQuestion', 'PayoutSuggestion']);
// PUBLIC API
export const dismissCashMovementQuestion = createAction('operations/dismiss-cash-movement-question', ['CashMovementQuestion']);
// PUBLIC API
export const confirmAccountReset = createAction('operations/confirm-account-reset', ['AccountResetSuggestion', 'Account', 'Trade', 'Payout']);
// PUBLIC API
export const dismissAccountReset = createAction('operations/dismiss-account-reset', ['AccountResetSuggestion']);
// PUBLIC API
export const createAccountGroup = createAction('operations/create-account-group', ['User', 'AccountGroup']);
// PUBLIC API
export const updateAccountGroup = createAction('operations/update-account-group', ['User', 'AccountGroup', 'Account', 'TradingStrategy']);
// PUBLIC API
export const deleteAccountGroup = createAction('operations/delete-account-group', ['User', 'AccountGroup', 'Account']);
// PUBLIC API
export const createPropFirmTemplate = createAction('operations/create-prop-firm-template', ['User', 'PropFirmTemplate', 'PropFirmAccountType', 'PropFirmTier', 'PropFirmPhase']);
// PUBLIC API
export const updatePropFirmTemplate = createAction('operations/update-prop-firm-template', ['User', 'PropFirmTemplate', 'PropFirmAccountType', 'PropFirmTier', 'PropFirmPhase']);
// PUBLIC API
export const deletePropFirmTemplate = createAction('operations/delete-prop-firm-template', ['User', 'PropFirmTemplate', 'PropFirmAccountType', 'PropFirmTier', 'PropFirmPhase']);
// PUBLIC API
export const upsertPropFirmAccountType = createAction('operations/upsert-prop-firm-account-type', ['User', 'PropFirmTemplate', 'PropFirmAccountType', 'PropFirmTier', 'PropFirmPhase']);
// PUBLIC API
export const deletePropFirmAccountType = createAction('operations/delete-prop-firm-account-type', ['User', 'PropFirmAccountType', 'PropFirmTier', 'PropFirmPhase']);
// PUBLIC API
export const upsertPropFirmPhase = createAction('operations/upsert-prop-firm-phase', ['User', 'PropFirmTier', 'PropFirmPhase']);
// PUBLIC API
export const deletePropFirmPhase = createAction('operations/delete-prop-firm-phase', ['User', 'PropFirmPhase']);
// PUBLIC API
export const createBlogPost = createAction('operations/create-blog-post', ['BlogPost']);
// PUBLIC API
export const updateBlogPost = createAction('operations/update-blog-post', ['BlogPost']);
// PUBLIC API
export const deleteBlogPost = createAction('operations/delete-blog-post', ['BlogPost']);
// PUBLIC API
export const publishBlogPost = createAction('operations/publish-blog-post', ['BlogPost']);
// PUBLIC API
export const unpublishBlogPost = createAction('operations/unpublish-blog-post', ['BlogPost']);
// PUBLIC API
export const createBlogCategory = createAction('operations/create-blog-category', ['BlogCategory']);
// PUBLIC API
export const updateBlogCategory = createAction('operations/update-blog-category', ['BlogCategory']);
// PUBLIC API
export const deleteBlogCategory = createAction('operations/delete-blog-category', ['BlogCategory', 'BlogPost']);
// PUBLIC API
export const previewPropFirmReferentialImport = createAction('operations/preview-prop-firm-referential-import', ['User', 'Account', 'PropFirmTemplate', 'PropFirmAccountType', 'PropFirmTier', 'PropFirmPhase']);
// PUBLIC API
export const applyPropFirmReferentialImport = createAction('operations/apply-prop-firm-referential-import', ['User', 'PropFirmTemplate', 'PropFirmAccountType', 'PropFirmTier', 'PropFirmPhase']);
// PUBLIC API
export const createComparatorFirm = createAction('operations/create-comparator-firm', ['ComparatorFirm']);
// PUBLIC API
export const updateComparatorFirm = createAction('operations/update-comparator-firm', ['ComparatorFirm']);
// PUBLIC API
export const deleteComparatorFirm = createAction('operations/delete-comparator-firm', ['ComparatorFirm', 'ComparatorOffer']);
// PUBLIC API
export const createComparatorOffer = createAction('operations/create-comparator-offer', ['ComparatorOffer']);
// PUBLIC API
export const updateComparatorOffer = createAction('operations/update-comparator-offer', ['ComparatorOffer']);
// PUBLIC API
export const deleteComparatorOffer = createAction('operations/delete-comparator-offer', ['ComparatorOffer']);
// PUBLIC API
export const duplicateComparatorOffer = createAction('operations/duplicate-comparator-offer', ['ComparatorOffer']);
// PUBLIC API
export const importComparatorOffersCsv = createAction('operations/import-comparator-offers-csv', ['ComparatorFirm', 'ComparatorOffer']);
// PUBLIC API
export const createFaqCategory = createAction('operations/create-faq-category', ['FaqCategory']);
// PUBLIC API
export const updateFaqCategory = createAction('operations/update-faq-category', ['FaqCategory']);
// PUBLIC API
export const deleteFaqCategory = createAction('operations/delete-faq-category', ['FaqCategory', 'FaqItem']);
// PUBLIC API
export const createFaqItem = createAction('operations/create-faq-item', ['FaqItem', 'FaqCategory']);
// PUBLIC API
export const updateFaqItem = createAction('operations/update-faq-item', ['FaqItem']);
// PUBLIC API
export const deleteFaqItem = createAction('operations/delete-faq-item', ['FaqItem']);
// PUBLIC API
export const createPayout = createAction('operations/create-payout', ['User', 'Account', 'Payout']);
// PUBLIC API
export const updatePayout = createAction('operations/update-payout', ['User', 'Account', 'Payout', 'WalletWithdrawal']);
// PUBLIC API
export const deletePayout = createAction('operations/delete-payout', ['User', 'Payout', 'Account', 'AccountAttachment', 'WalletWithdrawal']);
// PUBLIC API
export const requalifyPayout = createAction('operations/requalify-payout', ['User', 'Payout', 'Account']);
// PUBLIC API
export const createAccountCharge = createAction('operations/create-account-charge', ['User', 'Account', 'AccountCharge']);
// PUBLIC API
export const deleteAccountCharge = createAction('operations/delete-account-charge', ['User', 'AccountCharge']);
// PUBLIC API
export const updateAccountCharge = createAction('operations/update-account-charge', ['User', 'AccountCharge']);
// PUBLIC API
export const setChargeOccurrence = createAction('operations/set-charge-occurrence', ['User', 'AccountCharge', 'AccountChargeOccurrence']);
// PUBLIC API
export const splitChargeFrom = createAction('operations/split-charge-from', ['User', 'AccountCharge', 'AccountChargeOccurrence']);
// PUBLIC API
export const answerSubscriptionCancel = createAction('operations/answer-subscription-cancel', ['User', 'AccountCharge', 'Account']);
// PUBLIC API
export const importPropFirmHistory = createAction('operations/import-prop-firm-history', ['User', 'Account', 'Payout', 'AccountCharge', 'PropFirmTemplate', 'PropFirmAccountType', 'AccountGroup', 'TradingStrategy', 'PropFirmWallet', 'WalletTransfer', 'WalletWithdrawal', 'Notification']);
// PUBLIC API
export const upsertWalletInitialBalance = createAction('operations/upsert-wallet-initial-balance', ['User', 'PropFirmWallet', 'PropFirmTemplate']);
// PUBLIC API
export const createWalletTransfer = createAction('operations/create-wallet-transfer', ['User', 'PropFirmWallet', 'PropFirmTemplate', 'WalletTransfer', 'Account', 'Payout']);
// PUBLIC API
export const updateWalletTransferStatus = createAction('operations/update-wallet-transfer-status', ['User', 'PropFirmWallet', 'WalletTransfer']);
// PUBLIC API
export const createWalletPayout = createAction('operations/create-wallet-payout', ['User', 'PropFirmWallet', 'PropFirmTemplate', 'WalletWithdrawal', 'Account', 'Payout']);
// PUBLIC API
export const deleteWalletTransfer = createAction('operations/delete-wallet-transfer', ['User', 'PropFirmWallet', 'WalletTransfer', 'Account', 'Payout', 'TradovateSyncedAccount', 'PayoutSuggestion']);
// PUBLIC API
export const createWalletWithdrawal = createAction('operations/create-wallet-withdrawal', ['User', 'PropFirmWallet', 'WalletWithdrawal']);
// PUBLIC API
export const updateWalletWithdrawalStatus = createAction('operations/update-wallet-withdrawal-status', ['User', 'PropFirmWallet', 'WalletWithdrawal']);
// PUBLIC API
export const deleteWalletWithdrawal = createAction('operations/delete-wallet-withdrawal', ['User', 'PropFirmWallet', 'WalletWithdrawal', 'Payout', 'Account', 'AccountAttachment']);
// PUBLIC API
export const createTradingStrategy = createAction('operations/create-trading-strategy', ['User', 'TradingStrategy']);
// PUBLIC API
export const updateTradingStrategy = createAction('operations/update-trading-strategy', ['User', 'TradingStrategy']);
// PUBLIC API
export const deleteTradingStrategy = createAction('operations/delete-trading-strategy', ['User', 'TradingStrategy']);
// PUBLIC API
export const resyncTradesStrategies = createAction('operations/resync-trades-strategies', ['User', 'Account', 'Trade', 'TradingStrategy']);
// PUBLIC API
export const createPlaybook = createAction('operations/create-playbook', ['User', 'Playbook', 'TradingStrategy', 'Account', 'AccountGroup']);
// PUBLIC API
export const updatePlaybook = createAction('operations/update-playbook', ['User', 'Playbook', 'TradingStrategy', 'Account', 'AccountGroup']);
// PUBLIC API
export const deletePlaybook = createAction('operations/delete-playbook', ['User', 'Playbook']);
// PUBLIC API
export const askEdgyQuestion = createAction('operations/ask-edgy-question', ['User', 'EdgeReport', 'EdgyCredit', 'Trade', 'Playbook']);
// PUBLIC API
export const createAccountAttachmentUploadUrl = createAction('operations/create-account-attachment-upload-url', ['User', 'Account', 'AccountAttachment']);
// PUBLIC API
export const finalizeAccountAttachment = createAction('operations/finalize-account-attachment', ['User', 'Account', 'Payout', 'AccountAttachment']);
// PUBLIC API
export const deleteAccountAttachment = createAction('operations/delete-account-attachment', ['User', 'AccountAttachment']);
// PUBLIC API
export const generateSocialReport = createAction('operations/generate-social-report', ['User', 'Account', 'AccountGroup', 'PropFirmTemplate', 'TradingStrategy', 'Trade', 'Payout', 'AccountCharge', 'AccountChargeOccurrence', 'TradingSession', 'SocialReport']);
// PUBLIC API
export const renderReportImage = createAction('operations/render-report-image', ['SocialReport']);
// PUBLIC API
export const deleteSocialReport = createAction('operations/delete-social-report', ['SocialReport']);
// PUBLIC API
export const markNotificationsRead = createAction('operations/mark-notifications-read', ['User', 'Notification', 'MentorNotification']);
// PUBLIC API
export const dismissNotifications = createAction('operations/dismiss-notifications', ['User', 'Notification', 'MentorNotification']);
// PUBLIC API
export const createTradeCustomField = createAction('operations/create-trade-custom-field', ['User', 'TradeCustomFieldDefinition']);
// PUBLIC API
export const updateTradeCustomField = createAction('operations/update-trade-custom-field', ['User', 'TradeCustomFieldDefinition']);
// PUBLIC API
export const deleteTradeCustomField = createAction('operations/delete-trade-custom-field', ['User', 'TradeCustomFieldDefinition', 'TradeCustomFieldValue', 'TradeTagSuggestion', 'TradeColumnPreference']);
// PUBLIC API
export const createTradeTag = createAction('operations/create-trade-tag', ['User', 'TradeTag']);
// PUBLIC API
export const deleteTradeTag = createAction('operations/delete-trade-tag', ['User', 'TradeTag']);
// PUBLIC API
export const saveTradeColumnPreferences = createAction('operations/save-trade-column-preferences', ['User', 'TradeColumnPreference']);
// PUBLIC API
export const setEdgelyFlag = createAction('operations/set-edgely-flag', ['DashboardLayout']);
// PUBLIC API
export const adminDeleteLayout = createAction('operations/admin-delete-layout', ['DashboardLayout']);
// PUBLIC API
export const createLayout = createAction('operations/create-layout', ['User', 'DashboardLayout']);
// PUBLIC API
export const duplicateLayout = createAction('operations/duplicate-layout', ['User', 'DashboardLayout', 'DashboardRow', 'DashboardSlot']);
// PUBLIC API
export const renameLayout = createAction('operations/rename-layout', ['User', 'DashboardLayout']);
// PUBLIC API
export const deleteLayout = createAction('operations/delete-layout', ['User', 'DashboardLayout']);
// PUBLIC API
export const activateLayout = createAction('operations/activate-layout', ['User', 'DashboardLayout']);
// PUBLIC API
export const saveLayoutContent = createAction('operations/save-layout-content', ['User', 'DashboardLayout', 'DashboardRow', 'DashboardSlot', 'Notebook']);
// PUBLIC API
export const resetLayoutContent = createAction('operations/reset-layout-content', ['User', 'DashboardLayout', 'DashboardRow', 'DashboardSlot']);
// PUBLIC API
export const setLayoutShareToken = createAction('operations/set-layout-share-token', ['User', 'DashboardLayout']);
// PUBLIC API
export const importLayoutByShareToken = createAction('operations/import-layout-by-share-token', ['User', 'DashboardLayout', 'DashboardRow', 'DashboardSlot']);
// PUBLIC API
export const ensureDashboardDefaultLayout = createAction('operations/ensure-dashboard-default-layout', ['User', 'DashboardLayout', 'DashboardRow', 'DashboardSlot']);
// PUBLIC API
export const ensurePfmDefaultLayout = createAction('operations/ensure-pfm-default-layout', ['User', 'DashboardLayout', 'DashboardRow', 'DashboardSlot']);
// PUBLIC API
export const ensureJournalDefaultLayout = createAction('operations/ensure-journal-default-layout', ['User', 'DashboardLayout', 'DashboardRow', 'DashboardSlot']);
// PUBLIC API
export const ensureAnalyticsDefaultLayout = createAction('operations/ensure-analytics-default-layout', ['User', 'DashboardLayout', 'DashboardRow', 'DashboardSlot']);
// PUBLIC API
export const ensureSessionsDefaultLayout = createAction('operations/ensure-sessions-default-layout', ['User', 'DashboardLayout', 'DashboardRow', 'DashboardSlot']);
// PUBLIC API
export const ensureDisciplineDefaultLayout = createAction('operations/ensure-discipline-default-layout', ['User', 'DashboardLayout', 'DashboardRow', 'DashboardSlot']);
// PUBLIC API
export const applyLayoutToCustomPage = createAction('operations/apply-layout-to-custom-page', ['User', 'CustomPage', 'DashboardLayout', 'DashboardRow', 'DashboardSlot']);
// PUBLIC API
export const createCustomPage = createAction('operations/create-custom-page', ['User', 'CustomPage', 'DashboardLayout']);
// PUBLIC API
export const updateCustomPage = createAction('operations/update-custom-page', ['User', 'CustomPage', 'DashboardLayout']);
// PUBLIC API
export const deleteCustomPage = createAction('operations/delete-custom-page', ['User', 'CustomPage', 'DashboardLayout']);
// PUBLIC API
export const reorderCustomPages = createAction('operations/reorder-custom-pages', ['User', 'CustomPage']);
// PUBLIC API
export const createRoutine = createAction('operations/create-routine', ['User', 'TradingRoutine']);
// PUBLIC API
export const updateRoutine = createAction('operations/update-routine', ['User', 'TradingRoutine']);
// PUBLIC API
export const deleteRoutine = createAction('operations/delete-routine', ['User', 'TradingRoutine', 'RoutineCompletion']);
// PUBLIC API
export const completeRoutineItem = createAction('operations/complete-routine-item', ['User', 'TradingRoutine', 'RoutineCompletion']);
// PUBLIC API
export const createGoal = createAction('operations/create-goal', ['User', 'TradingGoal']);
// PUBLIC API
export const updateGoal = createAction('operations/update-goal', ['User', 'TradingGoal']);
// PUBLIC API
export const deleteGoal = createAction('operations/delete-goal', ['User', 'TradingGoal']);
// PUBLIC API
export const updateGoalProgress = createAction('operations/update-goal-progress', ['User', 'TradingGoal', 'GoalPeriodHistory', 'Trade']);
// PUBLIC API
export const createNotebook = createAction('operations/create-notebook', ['User', 'Notebook', 'NotebookCategory']);
// PUBLIC API
export const updateNotebook = createAction('operations/update-notebook', ['User', 'Notebook', 'NotebookCategory']);
// PUBLIC API
export const deleteNotebook = createAction('operations/delete-notebook', ['User', 'Notebook']);
// PUBLIC API
export const createNotebookCategory = createAction('operations/create-notebook-category', ['User', 'NotebookCategory']);
// PUBLIC API
export const updateNotebookCategory = createAction('operations/update-notebook-category', ['User', 'NotebookCategory']);
// PUBLIC API
export const deleteNotebookCategory = createAction('operations/delete-notebook-category', ['User', 'NotebookCategory', 'Notebook']);
// PUBLIC API
export const uploadNotebookImage = createAction('operations/upload-notebook-image', ['User', 'Notebook']);
// PUBLIC API
export const uploadNotebookImageDirect = createAction('operations/upload-notebook-image-direct', ['User', 'Notebook']);
// PUBLIC API
export const getNotebookImageDownloadUrl = createAction('operations/get-notebook-image-download-url', ['User']);
// PUBLIC API
export const uploadTradeImageDirect = createAction('operations/upload-trade-image-direct', ['User', 'Trade']);
// PUBLIC API
export const getTradeImageDownloadUrl = createAction('operations/get-trade-image-download-url', ['User', 'Trade']);
// PUBLIC API
export const resolveImageKeys = createAction('operations/resolve-image-keys', ['User']);
// PUBLIC API
export const createAnalysis = createAction('operations/create-analysis', ['User', 'Notebook']);
// PUBLIC API
export const updateAnalysis = createAction('operations/update-analysis', ['User', 'Notebook']);
// PUBLIC API
export const deleteAnalysis = createAction('operations/delete-analysis', ['User', 'Notebook']);
// PUBLIC API
export const seedUserDemoData = createAction('operations/seed-user-demo-data', ['User', 'TradingRoutine', 'RoutineCompletion', 'TradingGoal', 'Notebook']);
// PUBLIC API
export const seedForexAnalyses = createAction('operations/seed-forex-analyses', ['User', 'Notebook']);
// PUBLIC API
export const createTradingSession = createAction('operations/create-trading-session', ['User', 'TradingSession']);
// PUBLIC API
export const updateTradingSession = createAction('operations/update-trading-session', ['TradingSession', 'SessionError']);
// PUBLIC API
export const deleteTradingSession = createAction('operations/delete-trading-session', ['User', 'TradingSession']);
// PUBLIC API
export const createManualTradingSession = createAction('operations/create-manual-trading-session', ['User', 'TradingSession', 'SessionError']);
// PUBLIC API
export const confirmSessionMerge = createAction('operations/confirm-session-merge', ['PendingSessionMerge', 'TradingSession']);
// PUBLIC API
export const dismissSessionMerge = createAction('operations/dismiss-session-merge', ['PendingSessionMerge']);
// PUBLIC API
export const uploadSessionImageDirect = createAction('operations/upload-session-image-direct', ['User']);
// PUBLIC API
export const generateSessionShareLink = createAction('operations/generate-session-share-link', ['TradingSession']);
// PUBLIC API
export const createSessionError = createAction('operations/create-session-error', ['SessionError']);
// PUBLIC API
export const deleteSessionError = createAction('operations/delete-session-error', ['SessionError']);
// PUBLIC API
export const createTradingNoteTemplate = createAction('operations/create-trading-note-template', ['User', 'TradingNoteTemplate']);
// PUBLIC API
export const updateTradingNoteTemplate = createAction('operations/update-trading-note-template', ['User', 'TradingNoteTemplate']);
// PUBLIC API
export const deleteTradingNoteTemplate = createAction('operations/delete-trading-note-template', ['User', 'TradingNoteTemplate']);
// PUBLIC API
export const generateCheckoutSession = createAction('operations/generate-checkout-session', ['User']);
// PUBLIC API
export const syncStripeSubscription = createAction('operations/sync-stripe-subscription', ['User']);
// PUBLIC API
export const changeSubscriptionPlan = createAction('operations/change-subscription-plan', ['User']);
// PUBLIC API
export const createB2bPartnerAdmin = createAction('operations/create-b2b-partner-admin', ['B2bPartner']);
// PUBLIC API
export const rotateB2bPartnerKeyAdmin = createAction('operations/rotate-b2b-partner-key-admin', ['B2bPartner']);
// PUBLIC API
export const setB2bPartnerActiveAdmin = createAction('operations/set-b2b-partner-active-admin', ['B2bPartner']);
// PUBLIC API
export const adminCreateB2bGrant = createAction('operations/admin-create-b2b-grant', ['B2bPartner', 'B2bGrant', 'User', 'Notification']);
// PUBLIC API
export const adminRevokeB2bGrant = createAction('operations/admin-revoke-b2b-grant', ['B2bPartner', 'B2bGrant', 'User', 'Notification', 'MetaApiConnection', 'TradovateConnection']);
// PUBLIC API
export const updateMyAffiliatePayoutDetails = createAction('operations/update-my-affiliate-payout-details', ['User', 'AffiliateProfile']);
// PUBLIC API
export const requestAffiliatePayout = createAction('operations/request-affiliate-payout', ['User', 'AffiliateProfile', 'AffiliateCommission', 'AffiliatePayout']);
// PUBLIC API
export const createAffiliate = createAction('operations/create-affiliate', ['User', 'AffiliateProfile']);
// PUBLIC API
export const updateAffiliate = createAction('operations/update-affiliate', ['User', 'AffiliateProfile']);
// PUBLIC API
export const markAffiliatePayoutPaid = createAction('operations/mark-affiliate-payout-paid', ['User', 'AffiliatePayout', 'AffiliateCommission']);
// PUBLIC API
export const rejectAffiliatePayout = createAction('operations/reject-affiliate-payout', ['User', 'AffiliatePayout', 'AffiliateCommission']);
// PUBLIC API
export const createAffiliateAssetUploadUrl = createAction('operations/create-affiliate-asset-upload-url', ['User']);
// PUBLIC API
export const createAffiliateAsset = createAction('operations/create-affiliate-asset', ['User', 'AffiliateAsset']);
// PUBLIC API
export const updateAffiliateAsset = createAction('operations/update-affiliate-asset', ['User', 'AffiliateAsset']);
// PUBLIC API
export const deleteAffiliateAsset = createAction('operations/delete-affiliate-asset', ['User', 'AffiliateAsset']);
// PUBLIC API
export const createFileUploadUrl = createAction('operations/create-file-upload-url', ['User', 'File']);
// PUBLIC API
export const addFileToDb = createAction('operations/add-file-to-db', ['User', 'File']);
// PUBLIC API
export const deleteFile = createAction('operations/delete-file', ['User', 'File']);
// PUBLIC API
export const rerunTradovateBackfill = createAction('operations/rerun-tradovate-backfill', ['User', 'Trade', 'TradovateSyncedAccount', 'Account']);
// PUBLIC API
export const updateUserBetaTesterById = createAction('operations/update-user-beta-tester-by-id', ['User']);
// PUBLIC API
export const inviteStudent = createAction('operations/invite-student', ['User', 'MentorInvitation', 'MentorRelation']);
// PUBLIC API
export const revokeInvitation = createAction('operations/revoke-invitation', ['User', 'MentorInvitation']);
// PUBLIC API
export const resendInvitation = createAction('operations/resend-invitation', ['User', 'MentorInvitation']);
// PUBLIC API
export const revokeRelation = createAction('operations/revoke-relation', ['User', 'MentorRelation', 'MentorNotification']);
// PUBLIC API
export const markMentorNotificationsRead = createAction('operations/mark-mentor-notifications-read', ['User', 'MentorNotification']);
// PUBLIC API
export const inviteStudentsBatch = createAction('operations/invite-students-batch', ['User', 'MentorInvitation', 'MentorRelation']);
// PUBLIC API
export const createMentorNote = createAction('operations/create-mentor-note', ['User', 'MentorRelation', 'MentorNote', 'MentorNotification']);
// PUBLIC API
export const updateMentorNote = createAction('operations/update-mentor-note', ['User', 'MentorNote']);
// PUBLIC API
export const deleteMentorNote = createAction('operations/delete-mentor-note', ['User', 'MentorNote']);
// PUBLIC API
export const updateStudentPermissions = createAction('operations/update-student-permissions', ['User', 'MentorRelation', 'StudentPermissions']);
// PUBLIC API
export const revokeRelationAsStudent = createAction('operations/revoke-relation-as-student', ['User', 'MentorRelation', 'MentorNotification']);
// PUBLIC API
export const acceptInvitationByToken = createAction('operations/accept-invitation-by-token', ['User', 'MentorInvitation', 'MentorRelation', 'StudentPermissions', 'MentorNotification']);
// PUBLIC API
export const declineInvitationByToken = createAction('operations/decline-invitation-by-token', ['User', 'MentorInvitation', 'MentorNotification']);
//# sourceMappingURL=index.js.map